import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { EmailFolderEntity } from './email-folder.entity';
import { EmailProviderConnectionEntity } from './email-provider-connection.entity';
import { EmailRecordEntity } from './email-record.entity';
import { EmailSyncSubscriptionEntity } from './email-sync-subscription.entity';

@Entity('email_source')
@Index(['providerConnectionId', 'externalId'], { unique: true })
export class EmailSourceEntity extends BaseEntity {
	@Column({
		name: 'fk_email_provider_connection__id',
		type: 'int',
		unsigned: true,
	})
	public providerConnectionId!: number;

	@ManyToOne(() => EmailProviderConnectionEntity)
	@JoinColumn({ name: 'fk_email_provider_connection__id' })
	public providerConnection!: EmailProviderConnectionEntity;

	@Column({ name: 'external_id', type: 'varchar', length: 255, nullable: true })
	public externalId?: string;

	@Column({ name: 'name', type: 'varchar', length: 255, nullable: true })
	public name?: string;

	@Column({ name: 'color', type: 'varchar', length: 20, nullable: true })
	public color?: string;

	@Column({ name: 'sync_active', type: 'boolean', default: false })
	public syncActive!: boolean;

	@Column({ name: 'auto_sync_enabled', type: 'boolean', default: true })
	public autoSyncEnabled!: boolean;

	@Column({ name: 'sharing_enabled', type: 'boolean', default: false })
	public sharingEnabled!: boolean;

	@Column({ name: 'last_event_date', type: 'timestamp', nullable: true })
	public lastEventDate?: Date;

	@Column({ type: 'varchar', length: 255 })
	public type!: string; // 'email', 'calendar', etc.

	@Column({
		name: 'sync_cursor',
		type: 'varchar',
		length: 2048,
		nullable: true,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_as_cs',
	})
	public syncCursor?: string;

	@Column({ name: 'last_full_sync_date', type: 'timestamp', nullable: true })
	public lastFullSyncDate?: Date;

	@Column({ name: 'full_sync_from_date', type: 'timestamp', nullable: true })
	public fullSyncFromDate?: Date;

	@Column({
		name: 'processing_state',
		type: 'varchar',
		length: 50,
		nullable: true,
	})
	public processingState?: string;

	@Column({ name: 'processing_start_date', type: 'timestamp', nullable: true })
	public processingStartDate?: Date;

	@Column({ name: 'last_error', type: 'text', nullable: true })
	public lastError?: string;

	@Column({ name: 'error_count', type: 'int', unsigned: true, nullable: true })
	public errorCount?: number;

	@Column({ name: 'last_error_date', type: 'timestamp', nullable: true })
	public lastErrorDate?: Date;

	@Column({ name: 'last_auth_failure_date', type: 'timestamp', nullable: true })
	public lastAuthFailureDate?: Date;

	@OneToMany(() => EmailFolderEntity, (folder) => folder.emailSource)
	public folders!: EmailFolderEntity[];

	@OneToMany(() => EmailRecordEntity, (record) => record.emailSource)
	public records!: EmailRecordEntity[];

	@OneToMany(
		() => EmailSyncSubscriptionEntity,
		(subscription) => subscription.emailSource,
	)
	public subscriptions!: EmailSyncSubscriptionEntity[];
}
